export default function assessInput (componentElement, props, data, obj) {
    const result = {};
    if(data.correct_answer==="") return result;
    if(props.autoPoint && data.answer == (data.correct_answer ?? '')) result.assess_point = data.max_point; 
    return result;  
}